import { useTheme } from "@emotion/react"
import { Box, Button, Stack, CircularProgress } from "@mui/material"
import { ShieldCheck } from "@phosphor-icons/react"
import React, { useState } from "react"
import { Fragment } from "react"
import { GenericCircleIcon } from "../../../generic/GenericCircleIcon"
import { SIGN_IN_FORMS } from "../../../../enums/signInFormEnums"
import { signUp } from "../../../../config/apisauce"
import { TERMS } from "../../../../enums/termsAndConditions"

export const TermsAndConditions = ({ params, handleNextForm }) => {
  const [isLoading, setIsloading] = useState(false);

  const theme = useTheme();

  const handleAgree = async () => {
    setIsloading(true);
    const response = await signUp(params);
    if (response.ok) {
      handleNextForm(SIGN_IN_FORMS[2]);
    } else if (response?.data?.errors?.email_unverified) {
      handleNextForm(SIGN_IN_FORMS[4]);
    } else {
      handleNextForm(SIGN_IN_FORMS[0]);
    }
    setIsloading(false);
  };

  return (
    <Fragment>
      <Box display={'flex'} justifyContent={'center'} alignItems={'center'} mb={2}>
        <GenericCircleIcon>
          <ShieldCheck size={96} weight="thin" color={theme.palette.primary.main} />
        </GenericCircleIcon>
      </Box>
      <Box sx={{
        padding: '16px',
        backgroundColor: '#FFF',
        borderRadius: '16px',
      }}>
        <Box
          sx={{
            padding: '5px',
            height: { sm: '300px', md: '437px' },
            overflowX: 'auto',
          }}>
          {TERMS}
        </Box>
      </Box>
      <Stack direction={{ xs: 'column', sm: 'row' }} gap={1} mt={2} alignItems={'center'} justifyContent={'center'}>
        <Button variant="outlined" sx={{ width: { sm: '250px' } }} fullWidth onClick={() => handleNextForm(SIGN_IN_FORMS[0])}>Cancel</Button>
        <Button variant="contained" sx={{ color: "#FFF", width: { sm: '250px' } }} fullWidth onClick={() => handleAgree()} endIcon={isLoading && <CircularProgress size={14} color="inherit" />} disabled={isLoading}>I Agree</Button>
      </Stack>
    </Fragment >
  )
}